import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { UserRoutingModule } from './user-routing.module';

import { UserListComponent } from './user-list.component';
import { UserEditComponent } from './user-edit/user-edit.component';

import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [UserListComponent, UserEditComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, CoreModule, UserRoutingModule, TabsModule.forRoot(), BsDropdownModule.forRoot()],
  exports: [ UserListComponent, UserEditComponent]
})
export class UserModule {}
